import { createServiceAction } from '../util/actionHelper.js';
import { apiConfig } from '../configs/apiConfig.js';
import { getRequest, displayMessage } from '../util/index.js';
import { getHTTPStatusValidationMessage, getServerValidationMessage } from '../services/serverValidations.js';
import download from 'downloadjs';
import { put, takeEvery, call } from 'redux-saga/effects';

function* listener(serviceType, action) {
  try {
    yield put(createServiceAction(serviceType, 'loading')());
    if (action.data) {
      const options = {
        id: action.data.id,
        fileName: action.data.fileName,
        formType: action.data.formType
      };
      const infoPopDuration = 1000;

      const res = yield call(getRequest, apiConfig.downloadAttachment.endPointUrl, options);
      // Display HTTP status error message
      const statusErrorMessage = yield call(getHTTPStatusValidationMessage, res, infoPopDuration);
      if(!statusErrorMessage){
        const response = yield res.json();
        const shouldShowDownloadToast =
          action.data?.for === 'download' && action.data?.formType !== 'trainingMaterial';

        if (shouldShowDownloadToast) {
          yield call(displayMessage, 'info', action.data.fileName + ' is being downloaded..', infoPopDuration);
        }
        // Display server error message
        const serverErrorMessage = yield call(getServerValidationMessage, response, infoPopDuration);
        if (!serverErrorMessage && response.errorCode === 0) {
          const content = response?.data?.Content;
          if (!content) throw new Error('Attachment content is empty');

          const isUrl = typeof content === 'string' && /^https?:\/\//.test(content);

          if (isUrl) {
            if (action.data?.for === 'download') download(content, response.data.fileName, response.data.contentType);
            if (typeof action.data?.onSuccess === 'function') action.data.onSuccess(content, response);
          } else {
            const blob = base64ToBlob(content, response.data.contentType || 'application/pdf');
            const objectUrl = URL.createObjectURL(blob);

            if (action.data?.for === 'download') {
              download(blob, response.data.fileName, response.data.contentType);
            }
            if (typeof action.data?.onSuccess === 'function') {
              action.data.onSuccess(objectUrl, response);
            }

            yield put(createServiceAction(serviceType, 'success')(response));
          }
        }
      }
    }
  } catch (e) {
    yield put(createServiceAction(serviceType, 'error')(e));
  }
}

function* downloadAttachmentSagas() {
  const serviceType = 'downloadAttachment';
  yield takeEvery(createServiceAction(serviceType, 'requested').type, listener, serviceType);
}

export default downloadAttachmentSagas;

function base64ToBlob(base64, contentType = 'application/pdf', sliceSize = 1024) {
  const byteCharacters = window.atob(base64);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i += 1) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    byteArrays.push(new Uint8Array(byteNumbers));
  }

  return new Blob(byteArrays, { type: contentType });
}
